<div class="loader-container" [style]="height > 0 ? 'height: ' + height + 'px;' : ''">
  <div class="loader"></div>
</div>
